<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			v-if="sideOverShow"
			@click="sideOverShow = false"
		></div>
		<SideOver
			@close="sideOverShow = false"
			@submit="filterSubmit($event)"
			@cancel="filterSubmit($event)"
			@isFilterDate="isFilterDate = true"
			:staffs="staffs"
			:isAdmin="isAdmin"
			:isOpen="sideOverShow"
		/>
	</div>
	<div>
		<div v-if="!isLoading">
			<div class="mb-10" v-if="alertShow">
				<div
					class="
						bg-yellow-50
						border-l-4 border-yellow-600
						p-4
						rounded-md
					"
				>
					<div class="relative">
						<div class="flex items-center gap-4">
							<div>
								<img
									src="@/assets/images/logo/logo.svg"
									alt="luca-logo"
									height="24"
									width="35"
								/>
							</div>
							<div class="pt-1 text-neutral-600 text-sm">
								Dùng nền tảng ứng dụng di động tải về từ
								<a
									href="https://onelink.to/p88838"
									class="underline text-green-500 font-medium"
									>App Store/ CH Play</a
								>
								để tạo và chỉnh sửa báo cáo buổi học
							</div>
						</div>
						<div
							class="top-1 right-2 absolute cursor-pointer"
							@click="alertShow = false"
						>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
									fill="#E5A42B"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div v-if="reports?.length" class="__report-lesson__container">
				<div class="mb-8">
					<span
						class="
							text-sm
							inline-flex
							items-center
							py-1
							pl-3
							pr-2
							rounded-full
							bg-sienna-100
							text-neutral-900
							mr-2
							shadow-input
						"
						v-if="filter?.state === 'completed'"
					>
						Báo cáo đã hoàn thành
						<button
							type="button"
							class="
								flex-shrink-0
								ml-2
								h-4
								w-4
								rounded-full
								inline-flex
								items-center
								justify-center
								text-neutral-700
								hover:text-neutral-900
							"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="
							text-sm
							inline-flex
							items-center
							py-1
							pl-3
							pr-2
							rounded-full
							bg-sienna-100
							text-neutral-900
							mr-2
							shadow-input
						"
						v-if="filter?.state === 'incomplete'"
					>
						Báo cáo chưa nộp
						<button
							type="button"
							class="
								flex-shrink-0
								ml-2
								h-4
								w-4
								rounded-full
								inline-flex
								items-center
								justify-center
								text-neutral-700
								hover:text-neutral-900
							"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="
							text-sm
							inline-flex
							items-center
							py-1
							pl-3
							pr-2
							rounded-full
							bg-sienna-100
							text-neutral-900
							mr-2
							shadow-input
						"
						v-if="filter?.before && isFilterDate"
					>
						<span v-if="filter.toDate"
							>Từ
							{{ $filters.formatDate2(filter.toDate) }} đến</span
						><span class="ml-1">{{
							$filters.formatDate2(filter.before)
						}}</span>
						<button
							type="button"
							class="
								flex-shrink-0
								ml-2
								h-4
								w-4
								rounded-full
								inline-flex
								items-center
								justify-center
								text-neutral-700
								hover:text-neutral-900
							"
							@click="filterSubmit({ before: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="
							text-sm
							inline-flex
							items-center
							py-1
							pl-3
							pr-2
							rounded-full
							bg-sienna-100
							text-neutral-900
							mr-2
							shadow-input
						"
						v-if="filter?.staff_id"
					>
						{{
							staffById(filter.staff_id)
								? staffById(filter.staff_id).name
								: ''
						}}
						<button
							type="button"
							class="
								flex-shrink-0
								ml-2
								h-4
								w-4
								rounded-full
								inline-flex
								items-center
								justify-center
								text-neutral-700
								hover:text-neutral-900
								shadow-input
							"
							@click="filterSubmit({ staff_id: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="
							inline-flex
							items-center
							py-0.5
							rounded-full
							ml-2
							font-semibold
							cursor-pointer
							text-sm text-neutral-500
							hover:text-neutral-700
						"
						v-if="
							filter &&
							Object.keys(filter).length >= 0 &&
							isFilterDate
						"
						@click="filterSubmit(null)"
					>
						Xoá hết bộ lọc
					</span>
				</div>
				<div v-for="report in reports" :key="report.date" class="mb-10">
					<div class="relative mb-3">
						<div
							class="absolute inset-0 flex items-center"
							aria-hidden="true"
						>
							<div
								class="w-full border-t border-gray-300 mb-3.5"
							/>
						</div>
						<div class="relative flex justify-between">
							<div
								class="
									font-bold
									text-neutral-600 text-lg
									mb-3
									bg-body
									pr-3
								"
							>
								{{ $filters.formatDate2(report.date) }}
							</div>
							<div
								class="bg-body pl-3"
								@click="showHide(report.date)"
							>
								<button
									type="button"
									class="
										cursor-pointer
										button-p
										text-center
										bg-none
										shadow-none
										flex
										items-center
										justify-center
										btn--text
										w-fit
									"
								>
									<div
										class="mr-1 transform"
										:class="{
											'rotate-180': isHides.includes(
												report.date
											),
										}"
									>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M15 12.5L10 7.5L5 12.5"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</div>
									<span>{{
										isHides.includes(report.date)
											? 'Mở rộng'
											: 'Thu gọn'
									}}</span>
								</button>
							</div>
						</div>
					</div>
					<div
						class="
							grid
							gap-8
							md-down:gap-4
							mb-10
							md-down:grid-cols-1
							grid-cols-4
						"
					>
						<div
							class="
								bg-white
								p-4
								rounded-xl
								border-sm
								shadow-sm
								flex
								items-center
								justify-between
							"
						>
							<div class="text-neutral-500 text-sm">
								Buổi học đã diễn ra
							</div>
							<div class="text-neutral-600 font-bold text-4xl">
								{{ report?.stats?.total_count || 0 }}
							</div>
						</div>
						<div
							class="
								bg-white
								p-4
								rounded-xl
								border-sm
								shadow-sm
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="21"
									height="20"
									viewBox="0 0 21 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clip-path="url(#clip0_1704:5240)">
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z"
											fill="#2AA797"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z"
											fill="#2AA797"
										/>
									</g>
									<defs>
										<clipPath id="clip0_1704:5240">
											<rect
												width="20"
												height="20"
												fill="white"
												transform="translate(0.667969)"
											/>
										</clipPath>
									</defs>
								</svg>
								<div class="text-neutral-500 text-sm ml-2">
									Báo cáo hoàn thành
								</div>
							</div>
							<div
								class="
									flex
									items-center
									flex-nowrap
									justify-between
								"
							>
								<div
									class="text-neutral-600 font-bold text-4xl"
								>
									{{ report?.stats?.completed_count || 0 }}
								</div>
							</div>
						</div>
						<div
							class="
								bg-white
								p-4
								rounded-xl
								border-sm
								shadow-sm
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="21"
									height="20"
									viewBox="0 0 21 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clip-path="url(#clip0_1704:5253)">
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z"
											fill="#94A3B8"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z"
											fill="#94A3B8"
										/>
									</g>
									<defs>
										<clipPath id="clip0_1704:5253">
											<rect
												width="20"
												height="20"
												fill="white"
												transform="translate(0.332031)"
											/>
										</clipPath>
									</defs>
								</svg>
								<div class="text-neutral-500 text-sm ml-2">
									Báo cáo chưa hoàn thành
								</div>
							</div>
							<div
								class="
									flex
									items-center
									flex-nowrap
									justify-between
								"
							>
								<div
									class="text-neutral-600 font-bold text-4xl"
								>
									{{ report?.stats?.incomplete_count || 0 }}
								</div>
							</div>
						</div>
						<div
							class="
								bg-white
								p-4
								rounded-xl
								border-sm
								shadow-sm
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="21"
									height="20"
									viewBox="0 0 21 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M13.1978 10.0001C13.1978 11.5821 11.9152 12.8647 10.3332 12.8647C8.7511 12.8647 7.46859 11.5821 7.46859 10.0001C7.46859 8.41802 8.7511 7.1355 10.3332 7.1355C11.9152 7.1355 13.1978 8.41802 13.1978 10.0001Z"
										fill="#2AA797"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M1.1665 10.0001C1.1665 10.0001 4.604 3.698 10.3332 3.698C16.0623 3.698 19.4998 10.0001 19.4998 10.0001C19.4998 10.0001 16.0623 16.3022 10.3332 16.3022C4.604 16.3022 1.1665 10.0001 1.1665 10.0001ZM10.3332 14.0105C12.5481 14.0105 14.3436 12.215 14.3436 10.0001C14.3436 7.78519 12.5481 5.98966 10.3332 5.98966C8.11828 5.98966 6.32275 7.78519 6.32275 10.0001C6.32275 12.215 8.11828 14.0105 10.3332 14.0105Z"
										fill="#2AA797"
									/>
								</svg>
								<div class="text-neutral-500 text-sm ml-2">
									PH đã xem
								</div>
							</div>
							<div
								class="
									flex
									items-center
									flex-nowrap
									justify-between
								"
							>
								<div
									class="text-neutral-600 font-bold text-4xl"
								>
									{{
										report?.stats
											?.numbers_of_parent_read_count || 0
									}}
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="!isHides.includes(report.date)"
						class="shadow-sm sm:rounded-2xl overflow-hidden"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="
									overflow-hidden
									sm:rounded-t-2xl
									w-fit
									min-w-full
								"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-center text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													w-16
												"
											>
												STT
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													w-52
												"
											>
												tên lớp nhóm
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
												"
											>
												học sinh trong nhóm
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
												"
											>
												Mục tiêu
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
												"
											>
												Album
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
												"
											>
												Trạng Thái
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
												"
											>
												Gửi tới PH
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												PH ĐÃ XEM
											</th>
											<th
												scope="col"
												class="
													px-3
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
												"
											>
												Nộp bởi
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(item, index) in report.data"
											:key="item.id"
											:class="[
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50',
												!['new', 'created'].includes(
													item.state
												)
													? 'cursor-pointer hover:bg-orange-50'
													: '',
											]"
											class="text-neutral-700"
											@click.stop="
												!['new', 'created'].includes(
													item.state
												) &&
													$router.push(
														`/report/group/${item?.group_class?.id}/${item.id}`
													)
											"
										>
											<td>
												<div
													class="
														px-3
														py-4
														text-center
														text-neutral-700
													"
												>
													{{ index + 1 }}
												</div>
											</td>
											<td>
												<div
													class="
														px-3
														py-4
														text-neutral-700
													"
												>
													{{
														item?.group_class?.name
													}}
												</div>
											</td>
											<td
												class="
													px-3
													py-4
													whitespace-nowrap
													text-neutral-700
												"
											>
												<div
													v-if="
														item?.group_class
															?.students?.length
													"
												>
													<UserGroup
														:data="
															item?.group_class
																?.students
														"
													/>
												</div>
											</td>
											<td>
												<div
													class="px-3 py-4"
													style="
														max-width: 140px;
														margin-right: 40px;
													"
												>
													{{
														item?.goal_count || '0'
													}}/{{
														item?.group_goal_of_group_plan_count
													}}
												</div>
											</td>
											<td>
												<div class="px-3 py-4">
													<svg
														v-if="
															item.has_goal_media
														"
														width="21"
														height="21"
														viewBox="0 0 21 21"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M15.5019 5.80005H3.00193C2.31157 5.80005 1.75193 6.35969 1.75193 7.05005V17.05L5.05998 14.1081C5.27065 13.8975 5.60073 13.8648 5.84861 14.03L9.17229 16.2458L13.81 11.6081C14.0002 11.4179 14.2908 11.3707 14.5314 11.491L16.7519 13.9251V7.05005C16.7519 6.35969 16.1923 5.80005 15.5019 5.80005ZM3.00193 4.55005C1.62121 4.55005 0.501926 5.66934 0.501926 7.05005V17.05C0.501926 18.4308 1.62121 19.55 3.00193 19.55H15.5019C16.8826 19.55 18.0019 18.4308 18.0019 17.05V7.05005C18.0019 5.66934 16.8826 4.55005 15.5019 4.55005H3.00193ZM8.00193 10.175C8.00193 11.2106 7.16246 12.05 6.12693 12.05C5.09139 12.05 4.25193 11.2106 4.25193 10.175C4.25193 9.13951 5.09139 8.30005 6.12693 8.30005C7.16246 8.30005 8.00193 9.13951 8.00193 10.175Z"
															fill="#94A3B8"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M5 3.05005H18.5C19.0523 3.05005 19.5 3.49776 19.5 4.05005V15.05C19.5 15.6023 19.0523 16.05 18.5 16.05H18V17.05H18.5C19.6046 17.05 20.5 16.1546 20.5 15.05V4.05005C20.5 2.94548 19.6046 2.05005 18.5 2.05005H5C3.89543 2.05005 3 2.94548 3 4.05005V4.55005H4V4.05005C4 3.49776 4.44772 3.05005 5 3.05005Z"
															fill="#94A3B8"
														/>
													</svg>
												</div>
											</td>
											<td
												class="
													px-3
													py-4
													whitespace-nowrap
													text-neutral-700
												"
											>
												<div class="ml-6">
													<svg
														width="21"
														height="20"
														viewBox="0 0 21 20"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
														v-if="
															item.state ===
															'completed'
														"
													>
														<g
															clip-path="url(#clip0_1706:5649)"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M1.5 1.66667C1.5 0.746192 2.2397 0 3.15217 0H16.3696C17.282 0 18.0217 0.746192 18.0217 1.66667V8.81793C17.2564 8.50542 16.4199 8.33333 15.5435 8.33333C11.8936 8.33333 8.93478 11.25 8.93478 14.9319C8.93478 16.9231 9.80012 18.7784 11.1721 20H3.15217C2.2397 20 1.5 19.2538 1.5 18.3333V1.66667ZM2.73913 7.5C2.73913 7.26988 2.92406 7.08333 3.15217 7.08333H11C11.2281 7.08333 11.413 7.26988 11.413 7.5C11.413 7.73012 11.2281 7.91667 11 7.91667H3.15217C2.92406 7.91667 2.73913 7.73012 2.73913 7.5ZM2.73913 10C2.73913 9.76988 2.92406 9.58333 3.15217 9.58333H9.34783C9.57594 9.58333 9.76087 9.76988 9.76087 10C9.76087 10.2301 9.57594 10.4167 9.34783 10.4167H3.15217C2.92406 10.4167 2.73913 10.2301 2.73913 10ZM2.73913 12.5C2.73913 12.2699 2.92406 12.0833 3.15217 12.0833H7.69565C7.92377 12.0833 8.1087 12.2699 8.1087 12.5C8.1087 12.7301 7.92377 12.9167 7.69565 12.9167H3.15217C2.92406 12.9167 2.73913 12.7301 2.73913 12.5ZM2.73913 15C2.73913 14.7699 2.92406 14.5833 3.15217 14.5833H6.04348C6.2716 14.5833 6.45652 14.7699 6.45652 15C6.45652 15.2301 6.2716 15.4167 6.04348 15.4167H3.15217C2.92406 15.4167 2.73913 15.2301 2.73913 15ZM2.73913 3.75C2.73913 3.28976 3.10898 2.91667 3.56522 2.91667H14.7174C15.1736 2.91667 15.5435 3.28976 15.5435 3.75C15.5435 4.21024 15.1736 4.58333 14.7174 4.58333H3.56522C3.10898 4.58333 2.73913 4.21024 2.73913 3.75Z"
																fill="#2AA797"
															/>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M15.5435 20C18.2809 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2809 10 15.5435 10C12.8061 10 10.587 12.2386 10.587 15C10.587 17.7614 12.8061 20 15.5435 20ZM17.3834 13.106C17.5649 12.923 17.8591 12.923 18.0405 13.106C18.2198 13.2869 18.222 13.5786 18.0471 13.7622L15.5737 16.8811C15.5701 16.8856 15.5663 16.8899 15.5623 16.894C15.3808 17.077 15.0866 17.077 14.9051 16.894L13.2655 15.2399C13.084 15.0569 13.084 14.7601 13.2655 14.577C13.4469 14.394 13.7412 14.394 13.9226 14.577L15.2197 15.8855L17.3711 13.1201C17.3749 13.1151 17.379 13.1105 17.3834 13.106Z"
																fill="#2AA797"
															/>
														</g>
														<defs>
															<clipPath
																id="clip0_1706:5649"
															>
																<rect
																	width="20"
																	height="20"
																	fill="white"
																	transform="translate(0.5)"
																/>
															</clipPath>
														</defs>
													</svg>
													<svg
														width="21"
														height="20"
														viewBox="0 0 21 20"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
														v-else
													>
														<g
															clip-path="url(#clip0_1739:6086)"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
																fill="#94A3B8"
															/>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
																fill="#94A3B8"
															/>
														</g>
														<defs>
															<clipPath
																id="clip0_1739:6086"
															>
																<rect
																	width="20"
																	height="20"
																	fill="white"
																	transform="translate(0.5)"
																/>
															</clipPath>
														</defs>
													</svg>
												</div>
											</td>
											<td
												class="
													px-3
													py-4
													whitespace-nowrap
												"
											>
												<button
													v-if="
														item.state ===
															'completed' &&
														item.sent_at === null
													"
													class="
														button-p
														text-center
														btn--ghost
													"
													type="button"
													@click.stop="
														sendGroupReport(item)
													"
												>
													Gửi báo cáo
												</button>
												<div
													v-else-if="
														item.state ===
															'completed' &&
														item.sent_at
													"
												>
													Đã gửi
												</div>
												<div v-else>-</div>
											</td>
											<td>
												<div
													style="width: 100px"
													class="
														px-3
														py-4
														capitalize
														whitespace-nowrap
													"
												>
													{{
														item.numbers_of_parent_read ||
														'0'
													}}/
													{{
														item.group_class
															?.parents_count ||
														'0'
													}}
												</div>
											</td>
											<td
												class="
													px-3
													py-4
													whitespace-nowrap
													text-neutral-700
												"
											>
												<div
													@click.stop="
														$router.push(
															`/record/employee/${item?.submitted_by_staff?.id}`
														)
													"
													class="
														flex
														items-center
														cursor-pointer
														w-fit
														teacher
													"
													v-if="
														item?.submitted_by_staff
													"
												>
													<span
														class="
															inline-flex
															items-center
															justify-center
															h-6
															w-6
															rounded-full
														"
														:style="{
															background:
																item
																	?.submitted_by_staff
																	?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="
																text-xs
																font-medium
																leading-none
																text-white
															"
															>{{
																item
																	?.submitted_by_staff
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
													<div
														class="
															ml-4
															teacher__name
															font-semibold
															text-blue-600
														"
													>
														{{
															item
																?.submitted_by_staff
																?.name
														}}
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<DaInfinityLoading
					@infinite-load="getReportsList"
					:loaded="stopLoad"
					v-if="isInfinityLoading"
					:is-loading="isLoading"
				/>
			</div>
			<div
				v-else
				class="
					w-full
					h-full
					flex
					items-center
					justify-center
					flex-col
					mt-20
				"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div class="text-neutral-500 text-lg max-w-lg text-center">
					Cơ sở chưa có báo cáo cá nhân nào. Dùng app {{ $filters.terminology('teacher') }} để
					báo cáo kết quả học cá nhân hàng ngày của học sinh.
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import { Options, Vue, setup } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import SideOver from '@/views/groupClassReport/features/SideOver.vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading.vue';
import { useGetEmployees } from '@/views/record/employee/services/getEmployees';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Loading from '@/components/common/Loading.vue';
import { $api } from '@/services';
import UserGroup from '@/components/elements/UserGroup.vue';
import { _ROUTER_NAME } from '@/enums';

@Options({
	name: 'GroupClassReport',
	components: {
		UserGroup,
		Loading,
		DaInfinityLoading,
		SideOver,
		DaIcon,
	},
	props: {
		openFilter: {
			type: Number,
			default: 0,
		},
	},
})
export default class GroupClassReport extends Vue {
	sideOverShow = false;
	filter = null;
	payload = null;
	reports = [];
	dateNow = new Date();
	before = '';
	isFilterDate = false;
	stopLoad = false;
	staffs = [];
	isInfinityLoading = false;
	isLoading = true;
	alertShow = true;
	isHides = [];

	@Watch('openFilter')
	onOpenFilter(val) {
		if (val) {
			this.sideOverShow = true;
		}
	}

	//----------------------- 🤍 Setup 🤍 -----------------------//
	setup = setup(() => {
		const store = useStore();
		const { getEmployees } = useGetEmployees();
		return {
			getEmployees,
			store,
		};
	});

	//----------------------- 🤍 Getter 🤍 -----------------------//

	get isAdmin() {
		return this.setup.store.getters.isAdmin;
	}

	get org() {
		return this.setup.store.state.profile.current_org;
	}

	get store() {
		return this.setup.store;
	}

	//----------------------- 🤍 Created 🤍 -----------------------//
	created() {
		const q = this.$route.query;
		this.before = q.before ? dayjs(q.before).format('DD/MM/YYYY') : '';
		if (q?.before) {
			this.filter = {
				before: q?.before,
				toDate: q?.toDate,
			};
			this.isFilterDate = !!q?.before;
			this.before = dayjs(q.before).add(1, 'day').format('YYYY-MM-DD');
		}
		this.getReportsList();
		this.fetchStaffs();
	}

	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('$route')
	onRouterChange(value) {
		if (value?.name === _ROUTER_NAME.REPORT_GROUP) {
			this.reports = [];
			if (this.$route.query?.before) {
				this.before = dayjs(this.$route.query?.before.toString())
					.add(1, 'day')
					.format('YYYY-MM-DD');
			} else {
				this.before = '';
			}
			this.getReportsList();
		}
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	async getReportsList() {
		this.clean(this.payload);
		const q = this.$route.query;
		const { data } = await $api.groupClasses.fetchReports({
			...q,
			...this.payload,
			toDate: undefined,
		});
		if (
			data &&
			data.data.length > 0 &&
			(!this.filter?.toDate ||
				data?.date === this.filter.toDate ||
				dayjs(data?.date).isAfter(this.filter.toDate))
		) {
			this.reports.push({
				date: data?.date,
				data: data?.data,
				stats: data?.stats,
			});
			this.before = dayjs(data?.date).format('YYYY-MM-DD');
			this.payload = {
				...this.payload,
				before: this.before,
			};
		} else {
			this.stopLoad = true;
		}
		this.isInfinityLoading = true;
		this.isLoading = false;
	}

	async sendGroupReport(item) {
		try {
			const res = await $api.groupClasses.sendGroupReport(
				item.group_class_id,
				item.id
			);
			if (res?.data) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Gửi báo cáo thành công',
					type: 'success',
				});
				item.state = 'completed';
				item.sent_at = Date.now();
			}
		} catch (e) {
			await this.$store.dispatch('setAlertMessage', {
				message:
					e?.response?.data?.errors?.join('<br/>') ||
					'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}
	
	async fetchStaffs() {
		const res = await this.setup.getEmployees('');
		this.staffs = res?.data || [];
	}

	staffById(id) {
		return this.staffs.find((item) => item.id === id);
	}

	clean(obj) {
		for (let propName in obj) {
			if (
				obj[propName] === null ||
				obj[propName] === undefined ||
				obj[propName].length <= 0
			) {
				delete obj[propName];
			}
		}
		return obj;
	}

	filterSubmit(queryPa) {
		if (!queryPa) {
			this.before = dayjs(this.dateNow).format('DD/MM/YYYY');
			this.filter = null;
			this.$router.push('');
		} else {
			this.filter = {
				...this.filter,
				...queryPa,
			};
			this.clean(this.filter);
			const query = Object.keys(this.filter)
				.map((key) => `${key}=${this.filter[key]}`)
				.join('&');
			this.$router.push(`?${query}`);
		}
	}

	showHide(date) {
		const index = this.isHides.indexOf(date);
		if (index !== -1) {
			this.isHides.splice(index, 1);
		} else {
			this.isHides.push(date);
		}
	}

	beforeDestroy() {
		this.isInfinityLoading = false;
	}
}
</script>

<style lang="scss" scoped>
.teacher {
	&:hover {
		.teacher__name {
			text-decoration: underline;
			@apply text-yellow-500;
		}
	}
}
</style>
